import * as React from 'react';

const PuzzleRegularSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={48} height={48} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.438 27.562a3.557 3.557 0 01-2.988-1.628l-.591-.911H30V36h-9.062v-3.102a4.07 4.07 0 001.125-2.805 4.093 4.093 0 00-8.187 0 4.07 4.07 0 001.125 2.805V36H6V12h9.001v3.101a4.07 4.07 0 00-1.125 2.805 4.093 4.093 0 108.187 0 4.07 4.07 0 00-1.125-2.805V12H30v11.023h4.843l.589-.927a3.548 3.548 0 013.006-1.659 3.567 3.567 0 013.563 3.562 3.567 3.567 0 01-3.563 3.563zm0-9.125a5.556 5.556 0 00-4.694 2.586h-1.743V10H18.938v5.896l.546.579c.374.394.579.903.579 1.431A2.097 2.097 0 0117.969 20a2.096 2.096 0 01-2.093-2.094c0-.528.205-1.037.578-1.431l.547-.579V10H4v28h13.001v-5.897l-.547-.578a2.083 2.083 0 01-.578-1.432c0-1.154.939-2.093 2.093-2.093 1.155 0 2.094.939 2.094 2.093a2.08 2.08 0 01-.579 1.432l-.546.578V38h13.063V27.023h1.772a5.555 5.555 0 004.665 2.539 5.562 5.562 0 100-11.125z"
            fill="#39364F"
        />
    </svg>
);

PuzzleRegularSvg.displayName = 'PuzzleRegularSvg';
export default PuzzleRegularSvg;
